import $, { each } from 'jquery';
// Allows the use of jquery outside of main.js
window.jQuery = $; window.$ = $;

import 'slick-carousel';
import ScrollReveal from 'scrollreveal';



$(document).ready(function() {

	$('.menu-burger').on('click', function() {
		$('.menu-burger').toggleClass('menu-burger-active');
		$('.menu-primary-nav-container').toggleClass('menu-active');

		if ($(window).width() < 1280) {

			$('.header__nav').toggleClass('mob-active');
			$('body').toggleClass('scroll-lock');

			if ($('.header__nav').hasClass('mob-active')) {
				var target = $('.header__nav');
				$('html, body').stop().animate({
					scrollTop: $(target).offset().top
				}, 300);
			}

		}
	});

	$('.toggle-sub-menu').on('click', function() {
		$(this).next().toggleClass('sub-menu-active');
	});

	$('.header__search').on('click', function() {
		$('.search-form').toggleClass('search-form--active');
		$('.header__search').toggleClass('header__search--active');
	});

	$('.contact-info-reveal').on('click', function() {
		$(this).next().toggle();
	});

	$('.slider').slick({
        rows: 0,
        slide: '.slider__slide',
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		dots: true,
		arrows: false,
	  	infinite: true
	});

	$('.img-slider').slick({
		dots: true,
		arrows: false,
	  	infinite: true
	});

	$('.slider--courses').slick({
		dots: false,
		arrows: true,
	  	infinite: true,
		prevArrow: $('.prev-slide'),
		nextArrow: $('.next-slide')
	});

	$('.slider--members').slick({
		draggable: true,
		infinite: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$('.accordion__title').on('click', function() {
		$(this).children('.accordion__icon').toggleClass('accordion__icon--open');
		$(this).next('.accordion__content').slideToggle("slow", function() {
			// Animation complete.
		});
	});

	$('.popup-img-link').on('click', function() {
		var img_src = $(this).children('img').attr('src');
		var popup_el = '<div class="popup-img"><span class="popup-close"></span><img src="' + img_src + '"></div>';
		$('body').append(popup_el);
	});

	$(document).on('click','.popup-img',function() {
		$(this).remove();
	});

	window.sr = ScrollReveal();
	sr.reveal('.fade', { scale: '1', distance: '0px', delay: 250 });
	sr.reveal('.fade-in', { scale: '1', delay: 250 });
	sr.reveal('.fade-down', { duration: 750, origin: 'top', scale: '1', delay: 250 });
	sr.reveal('.fade-left', { duration: 750, origin: 'left', scale: '1', delay: 250 });
	sr.reveal('.fade-right', { duration: 750, origin: 'right', scale: '1', delay: 250 });
	sr.reveal('.fade-in-seq', { duration: 750, origin: 'bottom', scale: '1', delay: 250 }, 100);
	sr.reveal('.fade-down-seq', { duration: 750, origin: 'top', scale: '1', delay: 250 }, 100);
	sr.reveal('.fade-right-seq', { duration: 750, origin: 'right', scale: '1', delay: 250 }, 100);
	sr.reveal('.fade-right-seq-2', { duration: 750, origin: 'right', scale: '1', delay: 250 }, 100);

	$('.password-check, .confirm-password-check').keyup(checkPasswordMatch);

	function checkPasswordMatch() {
		var password = $('.password-check').val();
		var confirmPassword = $('.confirm-password-check').val();
	
		if (password != "" && confirmPassword != "") {
			if (password != confirmPassword) {
				$('#password_match').html("Passwords do not match!");
			} else {
				$('#password_match').html('');
			}
		}
	}

	if ($('body').hasClass('page-template-page-register')) {

		$('#register-form').submit(function (e) {
			e.preventDefault();
			var $daForm = $(this);
			$daForm.addClass('ajaxing');
			var form_data = $(this).serializeArray();
			$('#errors').html('');
			$.ajax({
				url: ajaxurl,
				data: form_data,
				// dataType: "json",
				success: function (response) {
					var data = JSON.parse(response);
					if (data.status == 'success' && data.recaptcha.success == true) {
						$daForm.trigger('reset').removeClass('ajaxing');
						window.location.href = "/register/thank-you/";
					} else if (data.status == 'fail' || data.recaptcha.success == false) {
						$daForm.removeClass('ajaxing');
						$('#errors').html('');
						$(data.errors).each(function (i, index) {
							$('#errors').append('<li>' + index + '</li>');
						});
						if (data.recaptcha.success == false) {
							$('#errors').append('<li>reCAPTCHA has failed.</li>');
						}
						setTimeout(function () {
							$('html, body').animate({ scrollTop: $("#errors").offset().top - 160 }, 1000);
						}, 10);
					}
					// console.log(data);
				},
				error: function (errorThrown) {
					console.log(errorThrown);
					$daForm.removeClass('ajaxing');
				}
			});
		});
	}

});

// run test on initial page load
checkSize();

// run test on resize of the window
$(window).resize(checkSize);

//Function to the css rule
function checkSize() {

	if ( $(".header__btns").css("clear") == "none" ) {
		$('.header__btns').prependTo('.menu-primary-nav-container');
	}

	if ( $(".header__btns").css("clear") == "both" ) {
		$('.header__btns').prependTo('#header-btns');
	}

	if ( $(".header__search").css("clear") == "none" ) {
		$('.header__search').prependTo('.header__nav');
	}

	if ( $(".header__search").css("clear") == "both" ) {
		$('.header__search').appendTo('#header-search');
	}

}




// Google Maps
function new_map( $el ) {

    // var
    var $markers = $el.find('.marker');


    // vars
    var args = {
        zoom		: 16,
        center		: new google.maps.LatLng(0, 0),
        mapTypeId	: google.maps.MapTypeId.ROADMAP
    };


    // create map
    var map = new google.maps.Map( $el[0], args);


    // add a markers reference
    map.markers = [];


    // add markers
    $markers.each(function(){

        add_marker( $(this), map );

    });


    // center map
    center_map( map );


    // return
    return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// marker type
	var type = 'marker.png';

	// icon
	var icon = {
	    url: '/app/themes/ivm/assets/img/' + type,
	    scaledSize: new google.maps.Size(40, 40),
	};

    // create marker
    var marker = new google.maps.Marker({
		id          : $marker.attr('data-name'),
		position	: latlng,
		map	    	: map,
		content     : $marker.html(),
		icon        : icon
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content		: $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {

            infowindow.open( map, marker );

        });
    }

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 16 );
    }
    else
    {
        // fit to bounds
        map.fitBounds( bounds );
    }

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

    $('.acf-map').each(function(){

        // create map
        map = new_map( $(this) );

    });

});